import Vue from 'vue'

const endpoints = {
  auth: {
    login: 'users/login',
    signup: 'users/signup'
  },
  upload: {
    files: 'file/upload'
  },
  file: {
    downloadByUid: 'files/{:id}/contents'
  },
  user: {
    profile: 'users/{:id}/profile',
    settings: 'users/{:id}/settings',
    list: 'users?expand=profile,agency,role',
    create: 'users',
    get: 'users/{:id}?expand=profile,agency,role',
    update: 'users/{:id}',
    ping: 'users/ping',
    setPassword: 'users/{:id}/set-password'
  },
  prospect: {
    setPassword: 'prospects/{:id}/set-password',
    list: 'prospects?expand=profile,agency,role',
    create: 'prospects',
    get: 'prospects/{:id}?expand=profile,agency,role,agency_id',
    update: 'prospects/{:id}'
  },
  apartment: {
    create: 'apartments',
    list: 'apartments?expand=data,creator,project',
    status: 'apartments/{:id}/status',
    get: 'apartments/{:id}?expand=data,creator,project,typeName',
    update: 'apartments/{:id}',
    link: 'apartments/{:id}/link-request/{:projectId}',
    unlink: 'apartments/{:id}/unlink-request/{:projectId}'
  },
  apartmentData: {
    create: 'apartments/{:parent}/data',
    list: 'apartments/{:parent}/data?expand=apartment',
    status: 'apartments/{:parent}/data/{:id}',
    get: 'apartments/{:parent}/data/{:id}?expand=apartment',
    update: 'apartments/{:parent}/data/{:id}'
  },
  project: {
    create: 'projects',
    list: 'projects?expand=accessItems',
    status: 'projects/{:id}/status',
    get: 'projects/{:id}?expand=apartments,apartments.data,creator,accessItems,modelFiles,files,images,fileSlots',
    update: 'projects/{:id}',
    attachImages: 'projects/{:id}/attach-images',
    attachFiles: 'projects/{:id}/attach-files',
    detachFiles: 'projects/{:id}/detach-files',
    setAccess: 'projects/{:id}/set-access'
  },
  agency: {
    create: 'agencies',
    list: 'agencies?expand=creator,subitems,userAgencies,salesCount',
    participants: 'agencies/{:id}/participants',
    addAgent: 'agencies/{:id}/add-participant/{:agentId}',
    deleteAgent: 'agencies/{:id}/delete-participant/{:agentId}',
    setRole: 'agencies/{:id}/set-role/{:agentId}',
    setPassword: 'agencies/{:id}/set-password/{:agentId}',
    status: 'agencies/{:id}/status',
    get: 'agencies/{:id}?expand=creator,subitems',
    update: 'agencies/{:id}',
    attachImages: 'agencies/{:id}/attach-images'
  },
  group: {
    create: 'groups',
    list: 'groups?expand=agency,creator,usersAssignedCount',
    status: 'groups/{:id}/status',
    get: 'groups/{:id}?expand=agency,creator,usersAssigned',
    update: 'groups/{:id}'
  },
  sale: {
    create: 'sales',
    list: 'sales?expand=apartments,client,creator,project',
    status: 'sales/{:id}/status',
    get: 'sales/{:id}?expand=project,apartments,apartments.data,activityLogs,modelFiles,fileSlots,client,workflowState,creator',
    update: 'sales/{:id}',
    workflowUpdate: 'sales/{:id}/workflow-update',
    slotWorkflowUpdate: 'sales/{:id}/slot-workflow-update',
    attachFiles: 'sales/{:id}/attach-files',
    detachFiles: 'sales/{:id}/detach-files',
    preReservationDownload: 'sales/{:id}/pre-reservation-download',
    addApartments: 'sales/{:id}/add-apartments',
    removeApartments: 'sales/{:id}/remove-apartments'
  },
  chat: {
    create: 'chats',
    get: 'chats/{:id}',
    getMessages: 'chats/{:id}/messages',
    sendMessage: 'chats/{:id}/send-message'
  },
  notification: {
    list: 'notifications'
  },
  config: {
    cleanup: 'tools/cleanup'
  }
}

console.log(process.env)
Vue.config.env = Object.assign({}, process.env)

if (Vue.config.env.NODE_ENV === 'production' || !process.env.VUE_APP_API_BASE_URL) {
  let parts = window.location.hostname.split('.')
  parts = parts.splice(1)
  let admin2api = window.location.hostname
  if (admin2api.match(/^admin\./)) {
    admin2api = 'api.' + parts.join('.')
  }
  Vue.config.API_BASE_URL = window.location.protocol + '//' + admin2api + '/v1/'
} else {
  Vue.config.API_BASE_URL = process.env.VUE_APP_API_BASE_URL
}

const appendBase = function (list) {
  Object.keys(list).map(key => {
    if (typeof list[key] === 'object') {
      appendBase(list[key])
    } else {
      list[key] = Vue.config.API_BASE_URL + list[key]
    }
  })
}

appendBase(endpoints)

export default endpoints
